import type { AyantDroitStatut } from '@cpce/shared';
import { commiteeMutation, MutationMethod } from '@/api/mutations.utils';
import { employeesQueryKeys } from '../employees/employees.query-keys';
import { employeesBeneficiariesQueryKeys } from '../employees-beneficiaries/employees-beneficiaries.query-keys';
import { beneficiariesQueryKeys } from './beneficiaries.query-keys';

export function useSetBeneficiaryStatus(id: number) {
  return commiteeMutation({
    url: `/commitee/:commiteeId/beneficiaries/${id}/status`,
    method: MutationMethod.PATCH,
    invalidateQueries: [beneficiariesQueryKeys.all, employeesBeneficiariesQueryKeys.all],
    body: (newStatus: AyantDroitStatut) => ({
      newStatus,
    }),
  });
}

export function useSetJustificatifValidationStatus() {
  return commiteeMutation({
    url: ({ justificatifId }) =>
      `/commitee/:commiteeId/beneficiaries/justificatifs/${justificatifId}/validation-status`,
    method: MutationMethod.PATCH,
    invalidateQueries: [
      beneficiariesQueryKeys.all,
      employeesBeneficiariesQueryKeys.all,
      employeesQueryKeys.all,
    ],
    body: ({
      validated,
      externalEmployeeId,
      documentName,
    }: {
      justificatifId: number;
      validated: boolean;
      externalEmployeeId: number;
      documentName: string;
    }) => ({ validated, externalEmployeeId, documentName }),
    successMessage: ({ validated }) => (validated ? 'Document validé' : 'Document refusé'),
  });
}
